// extracted by mini-css-extract-plugin
export var addButton = "_9v-0";
export var border = "_9v-8";
export var check = "_9v-h";
export var danger = "_9v-6";
export var dropdownContainer = "_9v-1";
export var editModalBody = "_9v-j";
export var footerContainer = "_9v-i";
export var fullWidth = "_9v-a";
export var hide = "_9v-9";
export var icon = "_9v-3";
export var input = "_9v-7";
export var inputFlex = "_9v-b";
export var inputWrapper = "_9v-c";
export var manualFocus = "_9v-5";
export var optionButton = "_9v-4";
export var pillWrapper = "_9v-e";
export var pointer = "_9v-2";
export var showOverflow = "_9v-f";
export var tagsFlex = "_9v-d";
export var xButton = "_9v-g";